import Vue from 'vue'

export default {
  setApp_mut(state, payload) {
    state.app = payload
    localStorage.setItem('app', payload)
  },

  setContracts_mut(state, payload) {
    state.contracts = payload
  },

  setProducts_mut(state, payload) {
    state.products = payload
  },

  setAccountInformation_mut(state, payload) {
    state.account = payload
    localStorage.setItem('account', JSON.stringify(payload))
  },

  setDepths_mut(state, payload) {
    state.depths = payload
  },

  setStreamingRate_mut(state, payload) {
    state.streamingRate = payload
    window.localStorage.setItem('streamingRate', JSON.stringify(payload))

    this.commit('setNextGetStreamingRate', new Date(payload.expired_at).getTime())
    state.getStreamingRate_apiStatus = 'success'
  },

  setBalances_mut(state, payload) {
    state.balances = payload
    state.balanceIdr = payload.balanceIdr
    state.balanceUsd = payload.balanceUsd
    state.availableTradeBalanceIdr = payload.availableTradeBalanceIdr
    state.availableTradeBalanceUsd = payload.availableTradeBalanceUsd
    state.reservedBalanceIdr = payload.reservedBalance
    state.reservedBalanceUsd = payload.reservedBalance
  },

  setGold_mut(state, payload) {
    const golds = window.structuredClone(state.golds)

    let tempGolds = golds
    if (golds) {
      for (const key in golds) {
        Vue.set(tempGolds, key, {
          ...golds[key],
          ...payload[key]
        })
      }
    } else {
      tempGolds = payload
    }
    
    state.golds = tempGolds
  },


  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },

  SET_GEOLOCATION(state, payload) {
    state.geolocation = payload
  },

  setAppName_mut(state, payload) {
    state.appName = payload
    localStorage.setItem('appName', payload)
  },

  setInstantLogin_mut(state, payload) {
    state.instantLogin = payload
    localStorage.setItem('instantLogin', JSON.stringify(payload))
  },

  SET_USER (state, payload) {
    state.user.email = payload.email
    state.user.full_name = payload.full_name
    state.user.phone_number = payload.phone_number
  },
  SET_TOKEN (state, token) {
    state.token = token
  }, 
  DESTROY_TOKEN(state) {
    state.token = null
  },
  DESTROY_USER(state){
    state.user.email = null
    state.user.full_name = null
    state.user.phone_number = null
  },
  SET_BALANCE(state, payload) {
    state.balanceIdr = payload.balanceIdr
    state.balanceUsd = payload.balanceUsd
    state.availableTradeBalanceUsd = payload.availableTradeBalanceUsd
    state.availableTradeBalanceIdr = payload.availableTradeBalanceIdr
    state.accountBalance = payload.accountBalance
    state.reservedBalance = payload.reservedBalance
  },
  SET_BALANCE_2(state, payload) {
    state.balanceIdr = payload.balanceIdr
    state.balanceUsd = payload.balanceUsd
  },
  
  CHANGE_SET_BALANCE_STATUS(state, payload){
    state.setBalanceStatus = payload
  },
  AUTH_REQUEST(state) {
    state.status = 'loading'
  },
  AUTH_LOGOUT(state, payload) {
    state.status = ''
    payload.forEach(item => state[item] = null)
  },
  AUTH_SUCCESS(state, payload) {
    state.token = payload.token
  },
  
  AUTH_CHANGE_STATUS(state, paylod) {
    state.status = paylod
  },

  AUTH_ERROR(state, error) {
    state.status = error
  },

  SET_DEMO_ACCOUNT_ID(state, payload) {
    state.demoAccountId = payload.accountId
    // state.demoToken = payload.sessionKey
  },

  SETDEPTHS(state, payload) {
    state.depths = payload
  },
  SET_KINESIS_DEPTH(state, payload) {
    state.kinesisDepth = payload
  },
  SETGOLD(state, payload) {
    state.gold = payload
  },
  SETPRODUCTS(state, payload) {
    state.products = payload
  },
  SETORDERINTRADETICKET(state, payload) {
    state.orderInTradeTicket = payload
  },
  SETACCOUNT(state, payload) {
    state.account = payload
  },
  START_TIMER(state) {
    state.timerBarStatus = true
  },
  STOP_TIMER(state) {
    state.timerBarStatus = false
  },
  SET_STREAMING_RATE(state, payload) {
    state.streamingRate = payload
  },

  // setStreamingRate_mut(state, payload) {
  //   state.streamingRate = payload
  //   this.commit('setNextGetStreamingRate', new Date(payload.expired_at).getTime())
  // },
  
  setNextGetStreamingRate(state, payload) {
    state.nextGetStreamingRate = payload
    window.localStorage.setItem('nextGetStreamingRate', payload)
  },

  CHANGE_CURRENCY(state, payload) {
    state.currency = payload
  },
  SET_CONTRACTS(state, payload) {
    state.contracts = payload
    state.setContracts = 'success'
  },
  CHANGE_TRADING_TYPE(state, payload) {
    state.tradingType = payload
  },
  CHANGE_GET_DEPOSIT_COOLDOWN_STATUS(state, payload) {
    state.getDepositIsCooldown = payload
  },

  SET_HOLDINGS(state, payload) {
    state.holdings = payload
  },

  SET_HUBS(state, payload) {
    state.hubs = payload
  },

  setCustomDepth(state, payload) {
    state.customDepths = payload
  },

  setGold(state, payload) {
    state.gold = payload
  },

  setReportToShow_mut(state, payload) {
    state.reportToShow = payload
    window.localStorage.setItem('tabActiveReports', payload)
  },

  // Api Status =============================================

  changeSetContractsApiStatus_mut(state, payload) {
    state.setContractsApiStatus = payload
  },

  changeSetProductsApiStatus_mut(state, payload) {
    state.setProductsApiStatus = payload
  },

  changeSetAccountInformationApiStatus_mut(state, payload) {
    state.setAccountInformationApiStatus = payload
  },
  
  changeSetDepthsApiStatus_mut(state, payload) {
    state.setDepthsApiStatus = payload
  },

  changeSetStreamingRateApiStatus_mut(state, payload) {
    state.getStreamingRate_apiStatus = payload
  },

  changeSetBalanceApiStatus_mut(state, payload) {
    state.setBalancesApiStatus = payload
  },


  CHANGE_MARKET_INQUIRY_STATUS(state, status) {
    state.marketInquiryStatus = status
  },
  CHANGE_MARKET_STATUS(state, status) {
    state.marketStatus = status
  },
  updateDataVideo(state, data){
    state.srcVideo = data
  },
  changeSetDetailOrder_status_mut(state, status) {
    state.setDetailOrder_status = status
  },

  CHANGE_SET_CONTRACTS_STATUS(state, status) {
    state.setContractsStatus = status
  },

  CHANGE_SWAL_SESSION_EXPIRED(state, status) {
    state.swalSessionExpiredOn = status
  },

  changeSetContractStatus(state, status) {
    state.setContractStatus = status
  }
}
